import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SpinnerState } from '../../interfaces/spinner-state.interface';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Spinner {
  state = input<SpinnerState | null>(null);
}
